export default [
  {
    fileName: "client/vn-dejun3.png",
    link: "https://upromania.ro/companii/card-de-tichete-de-masa-up-dejun/",
    category: "Banner",
    action: "Click",
    label: "Client_vn_dejun_45",
  },
];
